import React, {  useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setFilterSelected } from "pages/Mobility/ducks/MobilitySlice";
import { useDispatch, useSelector } from "react-redux";
import { TabItem, Tabs } from "@vds/core";

const getCategoryURI = (category) => `${category === "all" ? "" : category}/`;

const GridwallTabs = React.memo(function GridwallTabs({
  category,
  basePath,
  currentPath,
  setViewResults,
  isOCPO,
  deviceTabForOCPO,
  brandFilter,
  setBrandFilter,
  ...props
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pageData = useSelector((state) => state.MobilityPage);

  const { t } = useTranslation(["gridwall"]);
  const aemContent = useMemo(
    () => t("gridwall", { ns: "gridwall", returnObjects: true }),
    [t]
  );
  const freeOffers = aemContent?.free_offers
  const tabs = isOCPO
    ? deviceTabForOCPO
    : category === "tablets"
    ? aemContent?.tabletTabs
    : aemContent?.categoryTabs;
    
    
  if (tabs?.length) {
    let checkFreeOffers =  props?.filterData?.baseOfferList
    let isFreeOffers = false;
    if(checkFreeOffers && checkFreeOffers?.size){
    for(let obj of checkFreeOffers){
      if (obj[0] == freeOffers) isFreeOffers = true;
    }
  }
    
    return (
      <Tabs indicatorPosition="bottom" size="medium" borderLine="none">
        {tabs.map((tab) => (
          ((tab === "Free" && isFreeOffers && props?.enableFreeTab ) || tab !=="Free") ? 
          <TabItem
            key={tab}
            label={tab}
            active={ String(brandFilter).toLowerCase().includes(String(tab).toLowerCase()) || (!brandFilter && String(tab).toLocaleLowerCase().includes("all")) }
            onClick={() => {
              isOCPO
                ? navigate(
                    `${basePath}${
                      isOCPO ? "certified-pre-owned" : ""
                    }${getCategoryURI(category)}${
                      tab.toLowerCase() !== "all" ? tab.toLowerCase() : ""
                    }`
                  )
                : navigate(
                    `${basePath}${getCategoryURI(category)}${tab.toLowerCase()}`
                  );
                  if(tab.toLowerCase() == 'all' && !isOCPO){
                    dispatch(setFilterSelected({...pageData?.filterApplied,brandList: []}));
                    setBrandFilter('all');
                  }
            }}
            selected={ String(brandFilter).toLowerCase().includes(String(tab).toLowerCase()) || (!brandFilter && String(tab).toLocaleLowerCase().includes("all")) }
          />
          :<span/>
        ))}
      </Tabs>
    );
  } else return null;
});

export default GridwallTabs;
